// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'codebases'

/**
 * Codebase Model Interface (auto-generated from Drizzle schema)
 */
export interface CodebaseModel {
  id: string
  orgId: string
  workspaceId: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  name: string
  title: string
  description: string
  repository: Record<string, unknown>
  environment: Record<string, unknown>
  deployment?: Record<string, unknown>
  agentWorkflow?: Record<string, unknown>
  tags?: string[]
  status: string
  archivedAt?: string
  archived: boolean
  tenantId?: string
  gitProvider?: string
  gitNamespace?: string
  gitRepo?: string
  gitRepoId?: string
  gitDefaultBranch?: string
  gitConnectionId?: string
  gitVisibility?: string
  gitPushedAt?: string
  gitWebUrl?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "name": {
          "type": "string",
          "maxLength": 500
      },
      "title": {
          "type": "string",
          "maxLength": 500
      },
      "description": {
          "type": "string",
          "maxLength": 100000
      },
      "repository": {
          "type": "object"
      },
      "environment": {
          "type": "object"
      },
      "deployment": {
          "type": "object"
      },
      "agentWorkflow": {
          "type": "object"
      },
      "tags": {
          "type": "array",
          "items": {
              "type": "string"
          }
      },
      "status": {
          "type": "string",
          "maxLength": 50
      },
      "archivedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "archived": {
          "type": "boolean"
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      },
      "gitProvider": {
          "type": "string",
          "maxLength": 200
      },
      "gitNamespace": {
          "type": "string",
          "maxLength": 200
      },
      "gitRepo": {
          "type": "string",
          "maxLength": 200
      },
      "gitRepoId": {
          "type": "string",
          "maxLength": 100
      },
      "gitDefaultBranch": {
          "type": "string",
          "maxLength": 200
      },
      "gitConnectionId": {
          "type": "string",
          "maxLength": 100
      },
      "gitVisibility": {
          "type": "string",
          "maxLength": 200
      },
      "gitPushedAt": {
          "type": "string",
          "maxLength": 200
      },
      "gitWebUrl": {
          "type": "string",
          "maxLength": 200
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "name",
      "title",
      "description",
      "repository",
      "environment",
      "status",
      "archived",
      "workspaceId"
  ],
  indexes: [
      [
          "orgId",
          "createdAt"
      ],
      [
          "workspaceId",
          "createdAt"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
